import { action, observable, makeObservable } from "mobx";
import SocketCommunication from "../utils/SocketCommunication";
import { storage, STORAGE_KEYS } from "../utils/Storage";
import { tokenProcess } from "../utils/Token";
import { api } from "../utils/Api";
import UIStore from "./UIStore";

export default class UserStore {
  socket: SocketCommunication;
  uiStore: UIStore;
  private refreshTokenTimeout: NodeJS.Timeout | null = null;
  @observable userIsLogged = false;
  @observable isLoaded = false;
  @observable connectUrl = "";
  constructor(Socket: SocketCommunication, uiStore: UIStore) {
    this.uiStore = uiStore;
    this.socket = Socket;
    this.socket.on("setLoginUrl", ({ url }: any) => this.setUrl(url));
    this.socket.on("userIsLogged", (token: any) => this.setTokenAndLoggedUser(JSON.parse(token)));
    this.socket.on("destroySession", () => this.destroySession());
    this.socket.on("urlLogout", (url: string) => this.setLogout(url));
    makeObservable(this);
  }

  @action setLogout(url: string) {
    this.uiStore.logOutUrl = url;
  }
  @action async destroySession() {
    storage.removeItem(STORAGE_KEYS.TENANT_ID);
    storage.removeItem(STORAGE_KEYS.TENANT_NAME);
    storage.removeItem(STORAGE_KEYS.USER_ROLE);
    storage.removeItem(STORAGE_KEYS.USER_NAME);
    storage.removeItem(STORAGE_KEYS.API_TOKEN);
    storage.removeItem(STORAGE_KEYS.PW_TOKEN);
    this.uiStore.setTenantName("");
    this.uiStore.setUserRole("");
    this.uiStore.setUserName("");
    this.uiStore.changeSection("login");
    this.userIsLogged = false;
    this.uiStore.changeLoginStatus(false);
    if (this.refreshTokenTimeout) {
      clearTimeout(this.refreshTokenTimeout);
      this.refreshTokenTimeout = null;
    }
    const gretting = await tokenProcess();
    this.socket.emit("token", JSON.stringify(gretting));
  }

  @action setTokenAndLoggedUser(token: any) {
    storage.setItem(STORAGE_KEYS.API_TOKEN, token.token);
    storage.setItem(STORAGE_KEYS.TENANT_ID, token.tenantid);
    this.userIsLogged = true;
    this.fetchTenantInfo();
    this.fetchUserRole();
    this.fetchUserName();
    if (this.uiStore.section === "login") {
      this.uiStore.changeSection("import");
    }

    if (this.refreshTokenTimeout) {
      clearTimeout(this.refreshTokenTimeout);
    }
    this.refreshTokenTimeout = setTimeout(async () => {
      const gretting = await tokenProcess();
      this.socket.emit("refreshToken", JSON.stringify(gretting));
    }, 150000);
  }

  private async fetchUserName() {
    try {
      const { data } = await api.Get("users/GetUserName");
      const name: string = data?.Data?.UserName ?? "";
      if (name) this.uiStore.setUserName(name);
    } catch {
      // non-critical, ignore errors
    }
  }

  private async fetchUserRole() {
    try {
      const { data } = await api.OData("ApplicationUserRoles/GetUserRoles()");
      const principal = data?.value?.find((r: any) => r.IsPrincipal);
      if (principal?.Name) this.uiStore.setUserRole(principal.Name);
    } catch {
      // non-critical, ignore errors
    }
  }

  private async fetchTenantInfo() {
    try {
      const { data } = await api.Get("Tenants/TenantInfo");
      const name: string = data?.Data?.TenantName ?? "";
      if (name) this.uiStore.setTenantName(name);
    } catch {
      // non-critical, ignore errors
    }
  }

  @action setUrl(url: string) {
    this.connectUrl = url;
    this.setAsLoaded();
    this.uiStore.setSheetTitle();
  }

  @action setAsLoaded() {
    this.isLoaded = true;
  }
}
